import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/authContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { session, isLoading, isSessionReady } = useAuth();

  useEffect(() => {
    if (!isLoading && !session) {
      navigate('/login', { replace: true, state: { from: location.pathname } });
    }
  }, [isLoading, session, navigate, location.pathname]);

  // FE-SESSION-04: block render until session + user profile are confirmed
  if (isLoading || !isSessionReady) {
    return (
      <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center">
        <div className="text-center">
          <i className="ri-loader-4-line text-4xl text-[#16A34A] animate-spin" />
          <p className="text-[#6B7280] mt-4 text-sm">
            {isLoading ? 'Verificando sessão...' : 'Restaurando perfil...'}
          </p>
        </div>
      </div>
    );
  }

  if (!session) return null;

  return <>{children}</>;
};
